import { use } from 'react';
import { TeamContext } from '@/contexts/teamContext';

export function useTeam() {
  const context = use(TeamContext);
  if (!context) {
    throw new Error('useTeam must be used within a TeamProvider');
  }
  return context;
}
